import Button from '../../components/button';
import Modal from '../../components/modal';
import Headline6 from '../../components/headings/Headline6';



const  ConfirmationModal = (props:any) => {

    const Submit = () => {
      props.submit()
      props.onClose()
    }
 
    return (
      <Modal title="Availability" size="xsmall" onClose={props.onClose}>
          <div className="form-group">
          <Headline6>{props.logout ? 'Are you sure you want to log out?' : props.apply ? 'Are you sure to Continue ? ' : 'Are you sure to Continue?'}</Headline6>
          {props.apply && <p>{props.apply && props.apply.length > 0 ? `On submit of the new candidate ,All the ${props.apply.length} selected candidates will be applied to the position to Ellow.Click on continue to proceed.` : `On submitting profile , the candidate will be applied to Ellow for "${props.jobRole}"`}</p>}
          </div>
          <div className="popupAction">
            <Button variant='secondary'  onClick={props.onClose}>Cancel</Button>
            <Button variant='primary' onClick={Submit} >{props.logout ? 'Yes' : 'Continue'}</Button>
          </div>
        </Modal>
    )
}
export default  ConfirmationModal